import { Location, useLocation } from 'react-router-dom'

// Where the user was actually aimed before AppLayout detoured them into the
// wizard — undefined when they walked in themselves (the header's Get Started).
// AppLayout writes it as location state; NextPrev both honours it on the way out
// and forwards it on every step link, because a Link makes a new history entry
// and state does not ride along on its own.
export default function useOnboardFrom(): Location | undefined {
  return (useLocation().state as { from?: Location } | null)?.from
}
